import { STT_LANGUAGE_LIST } from "@/lib/constants";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import SettingsStore from "@/stores/SettingsStore";
import { useTranslation } from "react-i18next";
import { ControlWrapper } from "@/components/ui/control-wrapper";

export function LanguageSelect() {
  const { t } = useTranslation();
  const language = SettingsStore(state => state.language);
  const setLanguage = SettingsStore(state => state.setLanguage);
  const isLoading = SettingsStore(state => state.isLoading);

  return (
    <ControlWrapper>
      <Label htmlFor="language">{t("settings.language")}</Label>
      <Select
        value={language}
        onValueChange={setLanguage}
        disabled={isLoading}
      >
        <SelectTrigger id="language" className="w-full">
          <SelectValue placeholder={t("settings.language")} />
        </SelectTrigger>
        <SelectContent>
          {STT_LANGUAGE_LIST.map((lang) => (
            <SelectItem
              key={lang.key}
              value={lang.value}
            >
              {t(`languages.${lang.key}`)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </ControlWrapper>
  );
}